import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as clusterAssignedRecords from '../../cluster-assigned-records'
import * as records from '../../records'
import type { Collection } from '../collection'

/**
 * Reloads clusters when assigned records are created or deleted so cluster
 * assignment-derived fields stay current in every cluster surface.
 */
export const reloadOnClusterAssignmentChange = store.effects.create(
  (_: Collection['feature'], collection: Collection) =>
    rxjs
      .merge(
        ec.models.CollectionProducer.getEc$<clusterAssignedRecords.TypeParams>(
          ec.Name.Predefined.SpaceClusterAssignedRecord,
          { waitUntilReady: true },
        ).pipe(
          rxjs.switchMap(clusterAssignedRecordsEc =>
            clusterAssignedRecordsEc.plugins.editingPlugin.feature.actions.submit.success.observe(),
          ),
        ),
        ec.models.CollectionProducer.getEc$<records.TypeParams>(
          ec.Name.Predefined.SpaceRecord,
          { waitUntilReady: true },
        ).pipe(
          rxjs.switchMap(recordsEc =>
            recordsEc.plugins
              .lookup(records.plugins.clusterAssignment.Plugin)
              .getWhenReady$()
              .pipe(
                rxjs.switchMap(plugin =>
                  plugin.actions.submit.success.observe(),
                ),
              ),
          ),
        ),
      )
      .pipe(
        rxjs.map(action =>
          collection.plugins.currentListPlugin.feature.actions.load
            .from(action)
            .create(),
        ),
      ),
)
